import { render, staticRenderFns } from "./announce_signed_contract.vue?vue&type=template&id=0cc3d323&scoped=true&"
import script from "./announce_signed_contract.vue?vue&type=script&lang=js&"
export * from "./announce_signed_contract.vue?vue&type=script&lang=js&"
import style0 from "./announce_signed_contract.vue?vue&type=style&index=0&id=0cc3d323&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3d323",
  null
  
)

export default component.exports